module.exports = __webpack_public_path__ + "img/immersive-garden.252881bd.svg";